module.exports = __webpack_public_path__ + "static/img/cooperate.33bdd315.png";